<div class="container mt-5">
    <div class="row">
        <div class="col">
            <div class="card">
                <div class="card-header bg-primary text-white">
                    <div class="row align-items-center">
                        <p class="h3 m-0 col">Manage drop downs</p>
                        <div class="col text-right">
                            <button class="btn btn-outline-light btn-sm ml-2" (click)="add()">
                                Create drop down <i class="ml-2 fa fa-plus"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <table class="table">
                                <colgroup>
                                    <col class="col-auto">
                                    <col class="col-auto">
                                    <col class="col-auto">
                                    <col class="col-auto">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>Label</th>
                                        <th>Description</th>
                                        <th>Presentation Type</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let dropDown of dropDowns">
                                        <td><strong>{{dropDown.label}}</strong></td>
                                        <td>{{dropDown.description}}</td>
                                        <td>{{dropDown.presentationTypeName}}</td>
                                        <td (click)="editClicked(dropDown)" class="text-right"><i class="fa fa-pencil btn btn btn-icon"></i></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
